import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'

import GokuDataGrid from '@/components/GokuDataGrid'
import { generatePathDatacentral, paths } from '@/utils/path'
import { getPromosList } from '@/modules/Promo/services'
import { Promo } from '@/modules/Promo/types'
import { promoListColumns } from './columns'
import ActiveFilters from './Filters'

import EyeIcons from '@/icons/EyeIcons'

// Define outside component to prevent re-render
const FILTER_DEFAULT_VALUES = { status: '' }

const Active = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const actions: IAction<Promo>[] = [
        {
            onClick: (row) =>
                navigate(
                    generatePathDatacentral(paths.promoDetail, {
                        id: String(row?.promo_id),
                    })
                ),
            title: t('view'),
            color: 'primary',
            icon: <EyeIcons />,
        },
    ]

    return (
        <div className="my-2">
            <GokuDataGrid
                apiCall={getPromosList}
                columns={promoListColumns(t)}
                reactQueryKey="promo-active"
                actions={actions}
                dataGridProps={{
                    getRowId: (row) => row?.promo_id,
                }}
                searchPlaceholder={t('search_promo')}
                filterDefaultValues={FILTER_DEFAULT_VALUES}
            >
                {({ control, watch, setValue }) => (
                    <ActiveFilters
                        control={control}
                        watch={watch}
                        setValue={(name, value) => setValue(name as any, value)}
                    />
                )}
            </GokuDataGrid>
        </div>
    )
}

export default Active
